import userId from '../../lib/user-id'
import _ from 'lodash'

export const namespace = 'Session'

export default {
    namespaced: true,

    namespace,

    state: {
        queue: [],
        session: Math.random().toString(36).substring(2) + Date.now().toString(36),
        data: {},
    },

    mutations: {
        enqueue(state, { queued }) {
            state.queue.push(queued)
        },

        displayTimer(state, { id, displayEnding }) {
            const index = state.queue.findIndex(item => item.rule.id == id)
            if (index >= 0) {
                state.queue[index].displayEnding = displayEnding
            }
        },

        rememberDisplay(state, { id, display }) {
            const index = state.queue.findIndex(item => item.rule.id == id)
            if (index >= 0) {
                state.queue[index].display = display
            }
        },

        dequeue(state, { id }) {
            const index = state.queue.findIndex(item => item.rule.id == id)
            if (index >= 0) {
                state.queue.splice(index, 1)
            }
        },

        data(state, data) {
            _.merge(state.data, data)
        },
    },

    actions: {
        enqueue({ commit, state }, payload) {
            let queued = state.queue.find(item => item.rule.id == payload.rule.id)
            if (!queued) {
                queued = payload
                commit('enqueue', { queued })
            }
            return queued
        },

        displayTimer({ commit }, payload) {
            commit('displayTimer', payload)
        },

        rememberDisplay({ commit }, payload) {
            commit('rememberDisplay', payload)
        },

        dequeue({ commit }, payload) {
            commit('dequeue', payload)
        },

        data({ commit }, payload) {
            commit('data', payload)
        },
    },

    getters: {
        queue: state => state.queue,
        session: state => `${userId()}${state.session}`,
        data: state => state.data,
    },
}
